export default "__VITE_ASSET__54d79b1e__"